var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { baseColors } from '../../../Themes/colors';
export var filterChipSx = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 8px',
    borderRadius: '4px',
    border: "1px solid ".concat(baseColors.bluePreset[70]),
    backgroundColor: baseColors.bluePreset[60],
    color: baseColors.bluePreset[50],
    fontWeight: 500,
    whiteSpace: 'nowrap',
};
var FilterChip = function (_a) {
    var label = _a.label, onRemove = _a.onRemove, onClick = _a.onClick, _b = _a.maxLabelWidth, maxLabelWidth = _b === void 0 ? 200 : _b, sx = _a.sx;
    return (React.createElement(Box, { onClick: onClick, sx: __assign(__assign(__assign({}, filterChipSx), { flexShrink: 0, cursor: onClick ? 'pointer' : 'default' }), sx) },
        React.createElement(Box, { sx: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: baseColors.bluePreset[50],
                maxWidth: maxLabelWidth,
            } },
            React.createElement(Typography, { variant: "body2", sx: { fontSize: '13px', fontFamily: 'inherit', fontWeight: 400 } }, label)),
        onRemove && (React.createElement(IconButton, { size: "small", onClick: function (e) { e.stopPropagation(); onRemove(); }, sx: {
                p: 0,
                color: baseColors.bluePreset[80],
                '&:hover': { backgroundColor: 'transparent' },
            } },
            React.createElement("span", { className: "icon-close" })))));
};
export default FilterChip;
